const disbursementRequestDictionary = {
  getDisbursementRequestDetails: () =>
    `api/v1/partner/get-application-drf-details-by-application-id`,
};

export default disbursementRequestDictionary;
